import {AlertController, NavController, Keyboard, LoadingController} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {ReportWinLoss2ListPage} from "../reportWinLoss2List/reportWinLoss2List";

@Component({
  templateUrl: 'reportWinLoss2Search.html',
  selector: 'report-win-loss2-search-page',
})
export class ReportWinLoss2SearchPage {
  //排序方式
  status: number = 0;
  starttime: any;
  loginName: string;
  agentName: string;

  constructor(private keyboard: Keyboard,private nav: NavController, private alertCtrl: AlertController, private userService: UserService, private loadingCtrl: LoadingController) {
    this.initService();
  }

  initService() {
    this.userService.reportWinLoss2Init(undefined, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
         this.starttime = data["dates"];
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  searchFn() {
    let requestData: any = {
      order: this.status,
      loginname: this.loginName,
      dates: this.starttime.replace("T", ' ').substr(0, 19),
      agentname: this.agentName,
    };
    this.userService.reportWinLoss2List(requestData, this).then(data=> {
      if (!data["msg"]) {
        this.nav.push(ReportWinLoss2ListPage, {
          requestData: requestData,
          data: data
        });
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }

}



// WEBPACK FOOTER //
// ./src/pages/reportWinLoss2Search/reportWinLoss2Search.ts